module.exports = __webpack_public_path__ + "0907f7a75ad9a5748d315cd300849768.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/ribwort-plantain.jpg
 ** module id = 199
 ** module chunks = 0
 **/